export var DEFAULT_SESSION_IDLE_TITLE = "Still there?";
export var DEFAULT_SESSION_IDLE_MESSAGE = "It doesn't look any messages have been sent for a while, would you like to close this conversation or keep chatting?";
export var DEFAULT_SESSION_IDLE_TIMEOUT = 1800000;
export var DEFAULT_SESSION_IDLE_MODAL_TIMEOUT = 120000;
